"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Null character
 * @type {number}
 */
var NUL = exports.NUL = 0x00;
/**
 * Line feed character
 * @type {number}
 */
var LF = exports.LF = 0x0A;
/**
 * Horizontal tab character
 * @type {number}
 */
var HT = exports.HT = 0x09;
/**
 * Escape character
 * @type {number}
 */
var ESC = exports.ESC = 0x1B;
/**
 * Group separator character
 * @type {number}
 */
var GS = exports.GS = 0x1D;
/**
 * Space character
 * @type {number}
 */
var SP = exports.SP = 0x20;